/**
 * View title/description block.
 * @module volto-slate/blocks/Title/TitleBlockView
 */

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Slugger from 'github-slugger';
import { renderLinkElement } from '@plone/volto-slate/editor/render';
import { defineMessages, useIntl } from 'react-intl';
import { TextBlockView } from '@plone/volto-slate/blocks/Text';
import { Container, Grid } from 'semantic-ui-react';
import { Button } from '@redturtle/volto-io-studio/components';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';

/**
 * View title block component.
 * @class View
 * @extends Component
 */

const messages = defineMessages({
  linkTitleDefault: {
    id: 'Scopri di più',
    defaultMessage: 'Scopri di più',
  },
});

const PresentationTemplate = (props) => {
  const { properties, metadata, id, children, data } = props;
  const title = (properties || metadata)['title'];
  const slug = Slugger.slug(title);
  const attr = { id: slug || id };
  const LinkedTitle = useMemo(() => renderLinkElement('h1'), []);
  const intl = useIntl();

  return (
    <div className="block title">
      <div className="presentation-title full-width">
        <Container>
          <Grid className="block-content">
            <Grid.Row columns={2}>
              <Grid.Column
                computer={6}
                tablet={6}
                mobile={12}
                className="block-content--right"
              >
                {/* preTitolo */}
                {data?.preTitle && <p>{data.preTitle}</p>}

                {/* Titolo */}
                <LinkedTitle
                  mode="view"
                  children={
                    data?.variationTitle
                      ? data.variationTitle
                      : title ?? children
                  }
                  attributes={attr}
                  className={'documentFirstHeading'}
                />

                {/* Link */}
                {data?.linkHref?.length > 0 && (
                  <Button
                    as={UniversalLink}
                    className="cta-title"
                    href={data.linkHref[0]?.['@id']}
                    color="outline"
                    inverted
                    arrow
                  >
                    {data?.linkTitle ||
                      intl.formatMessage(messages.linkTitleDefault)}
                  </Button>
                )}
              </Grid.Column>

              <Grid.Column computer={6} tablet={6} mobile={12}>
                {/* Immagine */}
                {data.url && (
                  <div className="image-wrapper">
                    <img
                      src={`${flattenToAppURL(data.url)}/@@images/image`}
                      alt=""
                      className="title-image"
                      loading="lazy"
                    />
                  </div>
                )}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </div>
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
PresentationTemplate.propTypes = {
  properties: PropTypes.objectOf(PropTypes.any).isRequired,
  metadata: PropTypes.objectOf(PropTypes.any),
};

export default PresentationTemplate;
